.pillsContainer {
  display: flex;
  align-items: center;
  gap: 2px;
  z-index: 3;
}

.warningPill {
  background-color: rgba(255, 221, 31, 1);
  border-radius: 16px;
  padding-bottom: 2px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  [data-autopilot-system-redesign='on'] & {
    background-color: #ffc800;

    &.sm {
      width: 18px;
      height: 18px;
    }

    &.isV2 {
      border: 1px solid var(--dark-4);
      background: #ffc800;
      width: 18px;
      height: 18px;

      &.md {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.hybridAlert {
  background-color: var(--negative-20);
  color: var(--negative-60);
  border-radius: 16px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  [data-autopilot-system-redesign='on'] & {
    background-color: var(--red-50);
    color: var(--light-100);

    &.isV2 {
      border: 1px solid var(--dark-4);
      background: #ae2222;
      width: 18px;
      height: 18px;
      padding: 0 0 2px 0;

      &.md {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.statusCornerContainer {
  &.clickable {
    cursor: pointer;
  }
}
